import Vue from 'vue';
import Vuex from 'vuex';
import * as types from './mutation-types';

Vue.use(Vuex);

const state = {
	// ---- STATES ----

	states: [],
	cities: [],

	// ---- PRODUCTS ----

	products: [],
	current_product: {},
	current_product_parent: null,
	current_product_variation: null,
	current_product_ratings: [],
	current_product_edit: {},
	random_products: [],
  featureds: [],
  specials: [],
  news: [],
	loading_products: true,
	searching_product: false,

	// ---- USERS ----

	users: [],
	user_profile: {},
	current_user: {},

	// ---- SHOPPING CART ----

	shopping_cart: {},
	shopping_cart_address: {},
	shopping_cart_shipping: null,
	shopping_cart_payment: null,
	shopping_cart_index: 0,
	html: null,
	allow_continue: [
		true,
		false,
		false,
		false,
		false
	],

	// ---- WISH LIST ----

	wish_list: [],

	// ---- BILLING INFO ----

	billing_info: [],
	fedex_quote: 0,
	national_quote: 0,
	rfc_billing_info: {},

	// ---- RESULTS ----

	results: [],

	// ---- ORDERS ----

	orders: [],
	purchase_orders: [],

	// ---- SLIDERS ----

	sliders: [],
	public_sliders: [],

	// ---- CATEGORIES ----

	categories: [],
	current_category: {},

	// ---- PROJECTS ----

	projects: [],
	public_projects: [],
	current_project: {},

	// ---- NEWSLETTER ----

	newsletters: [],

	// ---- PROMO CODE ----

	promo_code: {},

	// ---- FILTERS ----

	min_price: 0,
	max_price: 50000,
	sub_id: 0,
	color: 0,

	// ---- COLORS ----

	colors: []
};

const mutations = {
	// ---- STATES ----

	[types.ADD_STATES] (state, states) {
		state.states.push(...states);
	},

	[types.ADD_CITIES] (state, cities) {
		state.cities = cities;
	},

	// ---- PRODUCTS ----

	[types.ADD_PRODUCTS] (state, products) {
		state.products.push(...products);
	},

	[types.SET_PRODUCT_VARIATION] (state, size) {
		state.current_product_variation = size;
	},

	[types.ADD_PRODUCT] (state, product) {
		state.products.push(product);
	},

	[types.SET_CURRENT_PRODUCT] (state, current_product) {
		state.current_product = current_product;
	},

	[types.SET_CURRENT_PRODUCT_RATINGS] (state, ratings) {
		state.current_product_ratings = ratings;
	},

	[types.ADD_RATE] (state, comment) {
		// state.current_product_ratings.push(comment);
	},

	[types.SET_CURRENT_PRODUCT_EDIT] (state, current_product_edit) {
		state.current_product_edit = current_product_edit;
	},

	[types.REMOVE_PRODUCT] (state, product) {
		for (let i = 0; i < state.products.length; i++) {
			if (product.id == state.products[i].id) {
				state.products.splice(i, 1);
			}
		}
	},

	[types.UPDATE_PRODUCT] (state, product) {
		for (let i = 0; i < state.products.length; i++) {
			if (product.id == state.products[i].id) {
				state.products[i] = product;
			}
		}
	},

	[types.SET_CURRENT_PRODUCT_PARENT] (state, parent) {
		state.current_product_parent = parent;
	},

	[types.RESET_CURRENT_PRODUCT_PARENT] (state) {
		state.current_product_parent = {};
	},

	[types.SET_RANDOMS] (state, products) {
		state.random_products = products;
	},

	[types.RESET_RANDOMS] (state) {
		state.random_products = [];
	},

	[types.SET_FEATUREDS] (state, products) {
		state.featureds = products;
	},

  [types.SET_SPECIALS] (state, products) {
    state.specials = products;
	},

  [types.SET_NEWS] (state, products) {
		state.news = products;
	},

	// ---- SHOPPING CART ----

	[types.SET_SHOPPING_CART] (state, shopping_cart) {
		state.shopping_cart = shopping_cart;
	},

	[types.GET_HTML] (state, html) {
		state.html = html;
	},

	[types.ADD_LOCAL_SHOPPING_CART] (state, product, quantity, variation) {
		let shopping_cart = {};
		// to hold if the product is already in
		// the shopping cart.
		let already_exists = false;
		// if the shopping cart not has products, create an array to
		// push them.
		if (!state.shopping_cart.products) {
			shopping_cart.products = [];
		} else {
			// if the shopping cart has products only take the products that are
			// in the shopping cart.
			shopping_cart.products = state.shopping_cart.products;
		}
		// check if the product exists, if exists only add the quantity.
		for (let i = 0, p = shopping_cart.products; i < p.length; i++) {
			if (!p[i].variation) {
				p[i].variation = 'M';
			}

			if (p[i].product.id == product.id && p[i].variation == variation) {
				already_exists = true;
				p[i].quantity = parseInt(quantity) + parseInt(p[i].quantity);
			}
		}
		// if exists dont push a new product to the shopping cart.
		if (!already_exists) {
			shopping_cart.products.push({
				quantity: quantity,
				product: product,
				variation: variation
			});
		}
		// set the shopping cart.
		state.shopping_cart = shopping_cart;
	},

	[types.REMOVE_LOCAL_SHOPPING_CART] (state, product) {
		let shopping_cart = {};
		shopping_cart.products = state.shopping_cart.products;
		// search the product to remove it.
		for (let i = 0, p = shopping_cart.products; i < p.length; i++) {
			if (p[i].product.id == product.product.id && p[i].variation == product.variation) {
				p.splice(i, 1);
			}
		}
		// set the shopping cart.
		state.shopping_cart = shopping_cart;
	},

	[types.SET_SHOPPING_CART_GUEST] (state, product) {
		if (!state.shopping_cart.products) {
			state.shopping_cart.user_id = 0;
			state.shopping_cart.products = [product];
		}

		state.shopping_cart.products.push(product);
	},

	[types.SET_SHOPPING_ADDRESS] (state, address) {
		state.shopping_cart_address = address;
	},

	[types.RESET_SHOPPING_ADDRESS] (state) {
		state.shopping_cart_address = {};
	},

	[types.SET_SHOPPING_SHIPPING] (state, shipping) {
		state.shopping_cart_shipping = shipping;
	},

	[types.SET_SHOPPING_PAYMENT] (state, payment) {
		state.shopping_cart_payment = payment;
	},

	[types.SET_SHOPPING_INDEX] (state, index) {
		state.shopping_cart_index = index;
	},

	// ---- USERS ----

	[types.SET_PROFILE_USER] (state, user) {
		state.user_profile = user;
	},

	[types.ADD_USERS] (state, users) {
		state.users.push(...users);
	},

	[types.DELETE_USER] (state, user) {
		for (let i = 0; i < state.users.length; i++) {
			if (user.id == state.users[i].id) {
				state.users.splice(i, 1);
			}
		}
	},

	[types.UPDATE_USER] (state, user) {
		if (user.id == state.current_user.user.id) {
			state.current_user.user = user;
		}

		for (let i = 0; i < state.users.length; i++) {
			if (user.id == state.users[i].id) {
				state.users[i] = user;
			}
		}
	},

	[types.SET_CURRENT_USER] (state, user) {
		state.current_user = user;
	},

	[types.UNSET_CURRENT_USER] (state) {
		state.shopping_cart = {};
		state.current_user = {};
		state.wish_list = [];
		state.purchase_orders = [];
		state.billing_info = [];
		state.shopping_cart_address = {};
		state.shopping_cart_shipping = null;
		state.shopping_cart_payment = null;
		state.shopping_cart_index = 0;
	},

	[types.UPDATE_ME] (state, user) {
		let c = state.current_user.user;
		let u = user;

		for (let k in c) {
			for (let e in u) {
				if (k == e)
					c[k] = u[e];
			}
		}
	},

	// ---- WISH LIST ----

	[types.SET_WISH_LIST] (state, wish_list) {
		state.wish_list = wish_list;
	},

	[types.ADD_PRODUCT_WISH_LIST] (state, product) {
		state.wish_list.push(product);
	},

	[types.REMOVE_PRODUCT_WISH_LIST] (state, product) {
		for (let i = 0; i < state.wish_list.length; i++) {
			if (product.id == state.wish_list[i].product_id) {
				state.wish_list.splice(i, 1);
			}
		}
	},

	// ---- BILLING INFO ----

	[types.SET_BILLING_INFO] (state, billing_info) {
		state.billing_info = billing_info;
	},

	[types.SET_RFC_BILLING_INFO] (state, billing_info) {
		if (billing_info.id) {
			billing_info.state_id = billing_info.city.ent_id;
			billing_info.city_id = billing_info.city.id;
		}

		state.rfc_billing_info = billing_info;
	},

	[types.ADD_BILLING_INFO] (state, billing_info) {
		if (!state.billing_info.length > 0) {
			state.billing_info = [];
		}

		state.shopping_cart_address = billing_info;
		state.billing_info.push(billing_info);
	},

	[types.REMOVE_BILLING_INFO] (state, billing_info) {
		for (let i = 0; i < state.billing_info.length; i++) {
			if (billing_info.id == state.billing_info[i].id) {
				state.billing_info.splice(i, 1);
			}
		}
	},

	[types.UPDATE_BILLING_INFO] (state, billing_info) {
		for (let i = 0, b = state.billing_info; i < b.length; i++) {
			if (b[i].id == billing_info.id) {
				// this solves an issue with re-render of billing infos.
				b.splice(i, 1, billing_info);
			}
		}
	},

	[types.SET_FEDEX_QUOTE] (state, quote) {
		state.fedex_quote = quote;
	},

	[types.RESET_FEDEX_QUOTE] (state) {
		state.fedex_quote = 0;
	},

	[types.SET_NATIONAL_QUOTE] (state, quote_national) {
		state.national_quote = quote_national;
	},

	[types.RESET_NATIONAL_QUOTE] (state) {
		state.national_quote = null;
	},

	// ---- RESULTS ----

	[types.SET_RESULTS] (state, results) {
		state.results = results;
	},

	// ---- ORDERS ----

	[types.GET_ORDERS] (state, orders) {
		state.orders.push(...orders);
	},

	[types.ADD_USER_PURCHASE_ORDERS] (state, purchase_orders) {
		state.purchase_orders.push(...purchase_orders);
	},

	// ---- SLIDERS ----

	[types.GET_SLIDERS] (state, sliders) {
		state.sliders = sliders;
	},

	[types.GET_PUBLIC_SLIDERS] (state, sliders) {
		state.public_sliders = sliders;
	},

	[types.ADD_NEW_SLIDER] (state, slider) {
		state.sliders.push(slider);
		state.public_sliders.push(slider);
	},

	[types.DELETE_SLIDER] (state, slider) {
		for (let i = 0; i < state.sliders.length; i++) {
			if (slider.id == state.sliders[i].id) {
				state.sliders.splice(i, 1);
				state.public_sliders.splice(i, 1);
			}
		}
	},

	// ---- CATEGORIES ----

	[types.GET_CATEGORIES] (state, categories) {
		state.categories = categories;
	},

	[types.SET_CURRENT_CATEGORY] (state, category) {
		state.current_category = category;
	},

	// ---- CONTRACT PROJECTS ----

	[types.GET_CONTRACT_PROJECTS] (state, projects) {
		state.projects.push(...projects);
	},

	[types.ADD_CONTRACT_PROJECT] (state, project) {
		state.projects.push(project);
		state.public_projects.push(project);
	},

	[types.DELETE_CONTRACT_PROJECT] (state, project) {
		for (let i = 0; i < state.projects.length; i++) {
			if (project.id == state.projects[i].id) {
				state.projects.splice(i, 1);
				state.public_projects.splice(i, 1);
			}
		}
	},

	[types.GET_PUBLIC_PROJECTS] (state, projects) {
		state.public_projects.push(...projects);
	},

	[types.SET_CURRENT_PROJECT] (state, project) {
		state.current_project = project;
	},

	// ---- PROMO CODES ----

	[types.SET_PROMO_CODE] (state, code) {
		state.promo_code = code;
	},

	// ---- FILTERS ----

	[types.SET_FILTER_PRICE] (state, min, max) {
		if (min && max) {
			state.min_price = min;
			state.max_price = max;
		}

		if (min) {
			state.min_price = min;
		}

		if (max) {
			state.max_price = max;
		}
	},

	[types.SET_FILTER_SUBCATEGORY] (state, sub) {
		state.sub_id = sub;
	},

	[types.SET_FILTER_COLOR] (state, color) {
		state.color = color;
	},

	[types.RESET_FILTER_PRICE] (state) {
		state.min_price = '1';
		state.max_price = '50000';
	},

	// ---- COLORS ----

	[types.SET_COLORS] (state, colors) {
		state.colors = colors;
	},

	[types.RESET_COLORS] (state) {
		state.colors = [];
	}
};

export default new Vuex.Store({
	state,
	mutations
});



// WEBPACK FOOTER //
// ./src/store/store.js